import { parseISO, parse, format } from 'date-fns';
import { ptBR, enUS, es } from 'date-fns/locale';
import { utcToZonedTime } from 'date-fns-tz';

const VALID_HOUR_FORMAT = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

const dateLocales = {
  'pt-BR' : ptBR,
  en      : enUS,
  es
};

const parseDate = (date, dateFormat = 'dd/MM/yyyy - HH:mm', locale = 'pt-BR') => {
  if (!date) {
    return '';
  }

  let parsedDate;

  if (typeof date === 'string' || date instanceof String) {
    parsedDate = parseISO(date);
  }

  return format(parsedDate, dateFormat, { locale: dateLocales[locale] });
};

/**
 * Rounds up time to nearest 'minutesToRound' minutes.
 *
 * @param {string} time - Time to be rounded in 'HH:mm' format.
 * @param {number} minutesToRound - Minutes to round time up. Defaults to 15 minutes.
 * @returns {string} Rounded time in 'HH:mm:ss' format.
 */
const roundUpTimeTo = (time, minutesToRound = 15) => {
  const roundUpTo = roundTo => x => Math.ceil(x / roundTo) * roundTo;
  const roundUpToMinutes = roundUpTo(1000 * 60 * minutesToRound);
  const roundedUp = roundUpToMinutes(parse(time, 'HH:mm', new Date()));
  return parseDate(new Date(roundedUp).toISOString(), 'HH:mm:ss');
};

const convertAndSeparateDateTime = (dateString) => {
  const dateUtc = new Date(dateString);
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const localDate = utcToZonedTime(dateUtc, timeZone);

  const formattedDate =  format(localDate, 'yyyy-MM-dd');
  const formattedTime =  format(localDate, 'HH:mm');

  return { date: formattedDate, time: formattedTime };
};

const hasTime = (dateString)=> {
  return dateString.match(/(\d{2}:\d{2}:\d{2})/);
};

export {
  parseDate,
  roundUpTimeTo,
  VALID_HOUR_FORMAT,
  convertAndSeparateDateTime,
  hasTime
};
